import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-primary text-complementary" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "hidden lg:flex" }
const _hoisted_4 = ["href", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LanguageSwitch = _resolveComponent("LanguageSwitch")!
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_Container, { class: "py-8 flex justify-between items-center" }, {
      default: _withCtx(() => [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "font-chakra text-xl sm:text-2xl uppercase" }, " Karol Jaskółka ", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("nav", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
              return (_openBlock(), _createElementBlock("a", {
                key: link.label,
                href: link.href,
                "aria-label": link.aria,
                class: "ml-8 first:ml-0 hover:text-gray flex animate-underline-tertiary"
              }, _toDisplayString(link.label), 9, _hoisted_4))
            }), 128))
          ]),
          _createVNode(_component_LanguageSwitch, { class: "ml-4 md:ml-12" })
        ])
      ]),
      _: 1
    })
  ]))
}